// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pprEntity from './entities/ppr.json';
import pprMenu from '../pages/ppr/menu.json';
import pprFullForm from '../pages/ppr/forms/full.json';
import pprContextForm from '../pages/ppr/forms/context.json';
import pprMiniForm from '../pages/ppr/forms/mini.json';
import pprLookupForm from '../pages/ppr/forms/lookup.json';
import pprTableView from '../pages/ppr/views/table.json';
import pprStagesView from '../pages/ppr/views/stages.json';
import pprCardsView from '../pages/ppr/views/cards.json';
import pprInlineView from '../pages/ppr/views/inline.json';
import pprBacklogView from '../pages/ppr/views/backlog.json';
import pprSplitView from '../pages/ppr/views/split.json';
import pprCalendarView from '../pages/ppr/views/calendar.json';
import pprDashboardView from '../pages/ppr/views/dashboard.json';

/** Тип запису «Позиційний документ» зі сторінками пакета: меню, форми та подання з pages/ppr/. */
export const pprDefinition: IRecordTypeDefinition = {
  ...pprEntity,
  views: assembleViewSet({
      table: pprTableView,
      stages: pprStagesView,
      cards: pprCardsView,
      inline: pprInlineView,
      backlog: pprBacklogView,
      split: pprSplitView,
      calendar: pprCalendarView,
      dashboard: pprDashboardView,
  }),
  form: pprFullForm,
  forms: { full: pprFullForm, context: pprContextForm, mini: pprMiniForm, lookup: pprLookupForm },
  menu: pprMenu,
} as IRecordTypeDefinition;
